/* ==========================================================================
   Noveliya — Vaak samen gekocht
   Live total, one Cart API call for everything selected, then hand the
   response to Dawn's cart drawer.
   ========================================================================== */

if (!customElements.get('nv-bundle')) {
  customElements.define(
    'nv-bundle',
    class NvBundle extends HTMLElement {
      connectedCallback() {
        this.inputs = Array.from(this.querySelectorAll('[data-nv-bundle-input]'));
        this.totalEl = this.querySelector('[data-nv-bundle-total]');
        this.button = this.querySelector('[data-nv-bundle-submit]');
        this.buttonLabel = this.querySelector('[data-nv-bundle-submit-label]');
        this.errorEl = this.querySelector('[data-nv-bundle-error]');
        this.spinner = this.querySelector('.loading__spinner');
        this.moneyFormat = this.dataset.moneyFormat || '€{{amount_with_comma_separator}}';

        this.inputs.forEach((input) => input.addEventListener('change', () => this.render()));
        this.button?.addEventListener('click', () => this.submit());

        /* The viewed product's price and variant change when a colour is picked,
           so the bundle total has to follow. */
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const locked = this.querySelector('[data-locked]');
            if (!locked || !data.variant) return;
            locked.dataset.variant = data.variant.id;
            locked.dataset.price = data.variant.price;

            const priceEl = this.querySelector('[data-nv-bundle-base-price]');
            const variantEl = this.querySelector('[data-nv-bundle-variant]');
            if (priceEl) priceEl.textContent = this.money(data.variant.price);
            if (variantEl) variantEl.textContent = data.variant.title;
            this.render();
          });
        }

        this.render();
      }

      get selected() {
        return this.inputs.filter((input) => input.hasAttribute('data-locked') || input.checked);
      }

      /* Minimal money formatter for the two placeholders a NL shop actually
         uses. Shopify's own formatMoney lives in a script we would otherwise
         have to load on every page just for this one line. */
      money(cents) {
        const amount = (cents / 100).toFixed(2);
        const [whole, frac] = amount.split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return this.moneyFormat
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${grouped},${frac}`)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, grouped)
          .replace(/\{\{\s*amount\s*\}\}/g, `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${frac}`);
      }

      render() {
        const picked = this.selected;
        const total = picked.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);

        if (this.totalEl) this.totalEl.textContent = this.money(total);

        if (this.buttonLabel) {
          const template = picked.length === 1 ? this.dataset.singleLabel : this.dataset.multiLabel;
          this.buttonLabel.textContent = (template || '').replace('1', picked.length) || 'Toevoegen';
        }
      }

      setLoading(state) {
        this.button?.classList.toggle('loading', state);
        this.button?.toggleAttribute('disabled', state);
        this.spinner?.classList.toggle('hidden', !state);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      async submit() {
        if (this.errorEl) this.errorEl.hidden = true;

        const items = this.selected.map((input) => ({ id: Number(input.dataset.variant), quantity: 1 }));
        if (!items.length) return;

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.setLoading(true);
        cart?.setActiveElement?.(document.activeElement);

        try {
          const body = { items };
          if (cart) {
            body.sections = cart.getSectionsToRender().map((section) => section.id);
            body.sections_url = window.location.pathname;
          }

          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body),
          });
          const result = await response.json();

          if (result.status) {
            this.showError(result.description || result.message);
            return;
          }

          if (cart) {
            cart.renderContents(result);
          } else {
            window.location = window.routes.cart_url;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv-bundle', cartData: result });
          }
        } catch (error) {
          this.showError('Toevoegen is niet gelukt. Controleer je verbinding en probeer het opnieuw.');
          console.error('[noveliya] bundle add failed:', error);
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
